import { render, staticRenderFns } from "./AgenteComponent.vue?vue&type=template&id=530ba35e&"
import script from "./AgenteComponent.vue?vue&type=script&lang=js&"
export * from "./AgenteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports